import styled, { keyframes, css } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const StyledLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  flex: 1;
`;

export const LoaderImage = styled('img')`
  animation: ${rotate} 1.5s linear infinite;
  transition: ${props => props.theme.animations.defaultTransition};
  display: block;
`;

export const LoaderText = styled.p`
  font-weight: ${props => props.theme.fonts.bold};
  color: ${props => props.theme.palette.primary};
  display: block;
`;
